import Urls from "./url"
import { Storage } from "@capacitor/storage";
import { User } from "../models/data";
import { createMedia } from "./media_service";

export const fetchUserFundraisers = async (id: any) => {
    const url = Urls('userfundraiserUrl', id);
    let resp = await fetch(url).then((resp) => {
        return resp
    })

    if (resp.ok) {
        return {
            message: await resp.json(),
            error: null
        }
    } else {
        return {
            message: null,
            error: resp.statusText
        }
    }
}
export const fetchAllFundraisers = async () => {
    const url = Urls('allFundraiserUrl');
    let resp = await fetch(url).then((resp) => {
        return resp
    })

    if (resp.ok) {
        return {
            message: await resp.json(),
            error: null
        }
    } else {
        return {
            message: null,
            error: resp.statusText
        }
    }
}
export const fetchSingleFundraiser = async (id: string) => {
    const url = Urls('singleFundraiserUrl', id);
    let resp = await fetch(url).then((resp) => {
        return resp
    })

    if (resp.ok) {
        return {
            message: await resp.json(),
            error: null
        }
    } else {
        return {
            message: null,
            error: resp.statusText
        }
    }
}
export const createFundraiser = async (data: any) => {
    let user: User;
    const { value } = await Storage.get({ key: 'user' });
    if (value) {
        user = JSON.parse(value);
        await createMedia(data.file).then(
            m => data.acf.image = m?.message
        );

        const createResponse = await fetch(Urls('createFundraiserUrl'), {
            method: 'POST', // *GET, POST, PUT, DELETE, etc.
            mode: 'cors', // no-cors, *cors, same-origin
            cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
            credentials: 'same-origin', // include, *same-origin, omit
            headers: {
                'Content-Type': 'application/json',
                // 'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': 'Bearer ' + user.token,
            },
            redirect: 'follow', // manual, *follow, error
            referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
            body: JSON.stringify({ title: data.title }) // body data type must match "Content-Type" header

        })
        if (createResponse.ok) {
            let message = await createResponse.json();
            let id = await message.id;
            let updateResponse = await updateFundraiser(data, id);
            if (updateResponse?.update_message) {
                return {
                    message: updateResponse.update_message,
                    error: updateResponse.update_error
                }
            } else {
                return {
                    message: updateResponse?.update_message,
                    error: updateResponse?.update_error
                }
            }
        } else {
            return {
                message: null,
                error: createResponse.statusText
            }
        }
    } else {
        console.log('no user');
    }
}

export const editFundraiser = async (data: any, id: any) => {
    // get user
    let user: User;
    let updateResponse;
    const { value } = await Storage.get({ key: 'user' });
    if (value) {
        user = JSON.parse(value);
        if (data.file!==undefined) {
            await createMedia(data.file).then(
                m => {
                    data.acf.image = m?.message

                    updateFundraiser(data, id).then(
                        n=>updateResponse=n
                    )
       
                }

            );
        } else {
            await updateFundraiser(data,id).then(
                l=>updateResponse=l
            )
        }

        return updateResponse;

    }
}
export const updateFundraiser = async (data: any, id: any) => {
    let user: User;
    const { value } = await Storage.get({ key: 'user' });

    let body = {
        title: data.title,
        status: data.status,
        acf: data.acf
    }
    if (value) {
        user = JSON.parse(value);
        const updateResponse = await fetch(Urls('updatFundraiserUrl', id), {
            method: 'POST', // *GET, POST, PUT, DELETE, etc.
            mode: 'cors', // no-cors, *cors, same-origin
            cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
            credentials: 'same-origin', // include, *same-origin, omit
            headers: {
                'Content-Type': 'application/json',
                // 'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': 'Bearer ' + user.token,
            },
            redirect: 'follow', // manual, *follow, error
            referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
            body: JSON.stringify(body) // body data type must match "Content-Type" header

        })
        let rsp = await updateResponse.json()
        if (updateResponse.ok) {
            return {
                update_message: rsp,
                update_error: null
            }
        } else {
            return {
                update_message: null,
                update_error: rsp
            }
        }
    } else {
        console.log('no user');
    }
}

export const createCredit = async (data: any) => {
    let user: User;
    const { value } = await Storage.get({ key: 'user' });
    if (value) {
        user = JSON.parse(value);
        const createResponse = await fetch(Urls('createCreditUrl'), {
            method: 'POST', // *GET, POST, PUT, DELETE, etc.
            mode: 'cors', // no-cors, *cors, same-origin
            cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
            credentials: 'same-origin', // include, *same-origin, omit
            headers: {
                'Content-Type': 'application/json',
                // 'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': 'Bearer ' + user.token,
            },
            redirect: 'follow', // manual, *follow, error
            referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
            body: JSON.stringify({ title: data.title }) // body data type must match "Content-Type" header

        })
        if (createResponse.ok) {
            let message = await createResponse.json();
            let id = await message.id;
            let updateResponse = await updateCredit(data, id);
            if (updateResponse?.update_message) {
                return {
                    message: updateResponse.update_message,
                    error: null
                }
            } else {
                return {
                    message: null,
                    error: updateResponse?.update_message
                }
            }
        } else {
            return {
                message: null,
                error: createResponse.statusText
            }
        }
    } else {
        console.log('no user');
    }
}
export const updateCredit = async (data: any, id: any) => {
    let user: User;
    const { value } = await Storage.get({ key: 'user' });

    let body = {
        status: data.status,
        acf: data.acf
    }
    if (value) {
        user = JSON.parse(value);
        const updateResponse = await fetch(Urls('updateCreditUrl', id), {
            method: 'POST', // *GET, POST, PUT, DELETE, etc.
            mode: 'cors', // no-cors, *cors, same-origin
            cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
            credentials: 'same-origin', // include, *same-origin, omit
            headers: {
                'Content-Type': 'application/json',
                // 'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': 'Bearer ' + user.token,
            },
            redirect: 'follow', // manual, *follow, error
            referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
            body: JSON.stringify(body) // body data type must match "Content-Type" header

        })
        if (updateResponse.ok) {
            return {
                update_message: await updateResponse.json(),
                update_error: null
            }
        } else {
            return {
                update_message: null,
                update_error: updateResponse.statusText
            }
        }
    } else {
        console.log('no user');
    }
}
export const fetchFundraiserProgress = async (id: any) => {

        let body = { id: id }

        let resp = await fetch(Urls('fundraiserProgressUrl'), {
            method: 'POST', // *GET, POST, PUT, DELETE, etc.
            mode: 'cors', // no-cors, *cors, same-origin
            cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
            credentials: 'same-origin', // include, *same-origin, omit
            headers: {
                'Content-Type': 'application/json',
                // 'Content-Type': 'application/x-www-form-urlencoded',
                //'Authorization': 'Bearer ' + user.token,
            },
            redirect: 'follow', // manual, *follow, error
            referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
            body: JSON.stringify(body) // body data type must match "Content-Type" header

        })

        if (resp.ok) {
            return {
                message: await resp.json(),
                error: null
            }
        } else {
            return {
                message: null,
                error: resp.statusText
            }
        }
    
}
export default {}